module.exports = __webpack_public_path__ + "img/LogoMastercard_Gris.4d2fdb1d.png";